import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import Loader from "../../../components/loader/Loader";

import {
  deletePortfolio,
  getPortfolio,
} from "../../../feature/portfolio/portfolioSlice";
import "./allPortfolio.scss";

const AllPortfolio = () => {
  const dispatch = useDispatch();
  const { isLoding, portfolio } = useSelector((state) => state.portfolio);
  useEffect(() => {
    dispatch(getPortfolio());
  }, [dispatch]);

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete && id) {
        dispatch(deletePortfolio(id));
        swal("Portfolio delete successfully", {
          icon: "success",
        });
      }
    });

    setTimeout(() => {
      window.location.reload(false);
    }, 3000);
  };

  return (
    <div className="all-port-container">
      {isLoding ? (
        <Loader />
      ) : (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Portfolio Title</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          {portfolio.allPortfolio &&
            portfolio.allPortfolio.map((data, index) => {
              return (
                <tbody key={data._id}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{data.title}</td>

                    <td>
                      <img src={`${data.image}`} alt="img" />
                    </td>
                    <td>
                      <Link to="/dashboard/edit_portfolio" state={data}>
                        <Button className="edit-btn port-action">Edit</Button>
                      </Link>

                      <Button
                        className="delete-btn port-action"
                        onClick={() => handleDelete(data._id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                </tbody>
              );
            })}
        </table>
      )}
    </div>
  );
};

export default AllPortfolio;
